'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FOCUSABLE = exports.FOCUSABLE = '\n  a[href]:not([tabindex="-1"]),\n  button:enabled:not([tabindex="-1"]),\n  input:enabled:not([tabindex="-1"]),\n  textarea:enabled:not([tabindex="-1"]),\n  select:enabled:not([tabindex="-1"]),\n  [tabindex]:not(:disabled):not([tabindex="-1"]),\n  [contenteditable]:not(:disabled):not([tabindex="-1"])\n';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/constants/Selectors.js
// module id = 166
// module chunks = 3 4 5